export default __webpack_public_path__ + "static/cards-ro-1b7e7935bba83cbb4b9dfdd019797087.png";